module.exports = __webpack_public_path__ + "media/images/etiqa_dropdown@2x-262bd5ab8624cbfa6040cd9ce3aacd33.jpg";